import moment from 'moment'

/**
 * 工作台专家学历，地址请求参数
 * @author wyc
 * @date 2024-5-29 17:29:11
 * @type {string}
 */
export const FieldList = 'education,area_address'

export const RowData = {
  education: {
    name: '学历',
    num: '专家数'
  },
  area_address: {
    name: '位置',
    num: '专家数'
  },
}

/**
 * 最近任务日期
 * @type {[{name: string, value: string},{name: string, value: string},{name: string, value: string}]}
 */
export const NearestDateList = [
  {
    name: '今天',
    value: '0'
  },
  {
    name: '明天',
    value: '1'
  },
  {
    name: '后天',
    value: '2'
  }
]

//标注图标
export const MarkPointImg = 'image://data:image/png;base64,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'

/**
 * 待抽取专家列表table 表头
 * @type {[{scopedSlots: {customRender: string}, dataIndex: string, width: string, title: string, key: string},{customRender: (function(*): *), dataIndex: string, title: string, align: string, key: string},{customRender: (function(*): string), dataIndex: string, title: string, align: string, key: string},{customRender: (function(*): string), dataIndex: string, title: string, align: string, key: string, ellipsis: boolean},{customRender: (function(*): string), dataIndex: string, title: string, align: string, key: string, ellipsis: boolean},null,null]}
 */
export const pendingExpertExtractColumns = [
  {
    title: '项目名称',
    dataIndex: 'projectName',
    key: 'projectName',
    width: '40%',
    scopedSlots: { customRender: 'projectName' },
  },
  {
    title: '开标时间',
    dataIndex: 'openDate',
    key: 'openDate',
    align: 'center',
    customRender: (text) => {
      return text && moment(text).format('MM-DD HH:mm')
    }
  },
  {
    title: '需抽取人数',
    dataIndex: 'expertNumber',
    key: 'expertNumber',
    align: 'center',
    customRender: (text) => {
      return `${text}人`
    }
  },
  {
    title: '已抽取人数',
    dataIndex: 'allExtractNum',
    key: 'allExtractNum',
    ellipsis: true,
    align: 'center',
    customRender: (text, record) => {
      return record.recordNum ? `已抽取${record.recordNum}轮 ${text}人` : `${text}人`
    }
  },
  {
    title: '同意参加人数',
    dataIndex: 'attendNum',
    key: 'attendNum',
    ellipsis: true,
    align: 'center',
    customRender: (text) => {
      return `${text}人`
    }
  },
  {
    title: '待通知人数',
    dataIndex: 'uncertainNum',
    key: 'uncertainNum',
    ellipsis: true,
    align: 'center',
    customRender: (text) => {
      return `${text}人`
    }
  },
  {
    title: '状态',
    key: 'action',
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },

]

/**
 * 更多跳转-详情跳转
 */
export const JumpUrl = {
  // 待审核的申请
  pendingAuditApplyForTask: {
    moreUrl: '/audit/applyfor/index',
  },
  // 专家请假需补抽的任务
  drawTask: {
    moreUrl: '/selectExpertApply/index',
    viewUrl: '/selectExpertApply/view'
  },
  // 待处理的专家抽取任务
  pendingExpertExtractTask: {
    moreUrl: '/selectExpertApply/index',
    viewUrl: '/selectExpertApply/view',
    editUrl: '/selectExpertApply/edit'
  },
  // 已解密待审核
  completeUnDecryptTask: {
    moreUrl: '/selectExpertApply/index',
    viewUrl: '/selectExpertApply/view'
  },
  //最近任务
  nearestExtractTask: {
    moreUrl: '/selectExpertApply/index',
    viewUrl: '/selectExpertApply/view'
  }
}









